import { PayPalScriptProvider, PayPalButtons, FUNDING } from "@paypal/react-paypal-js";
import { message } from "antd";

type Props = {
  styles: Object,
  createOrder: Function,
  onApprove: Function,
  payPalClientId: String,
  currency: String,
  country: String,
  accountSupportedPaymentTypes?: Array<String>,
}

const PayPalCheckout = (props: Props) => {
  const {styles, createOrder, onApprove, payPalClientId, currency, country, accountSupportedPaymentTypes } = props;
  const env = process.env.REACT_APP_ENV;
  let initialOptions = {};
  if (env === "Production") {
    initialOptions = {
    "client-id": payPalClientId,
    currency: currency,
    intent: "capture",
    "enable-funding": "venmo",
    "disable-funding": "card,paylater",
  };
  } else if (env !== "Production") {
    initialOptions = {
    "client-id": payPalClientId,
    currency: currency,
    intent: "capture",
    "enable-funding": "venmo",
    "disable-funding": "card,paylater",
    "buyer-country": country,
  };
  }

  let fundingSource = undefined;
  if (accountSupportedPaymentTypes) {
    const hasVenmo = accountSupportedPaymentTypes.includes("VENMO");
    const hasPaypal = accountSupportedPaymentTypes.includes("PAYPAL_WALLET");
    if (hasVenmo && !hasPaypal) {
      fundingSource = FUNDING.VENMO;
    } else if (hasPaypal && !hasVenmo) {
      fundingSource = FUNDING.PAYPAL;
    }
  }

  return (
   <PayPalScriptProvider options={initialOptions}>
     <PayPalButtons
       fundingSource={fundingSource}
       style={styles}
       createOrder={createOrder}
       onApprove={onApprove}
       onError={() =>
       message.error(
        "Please perform the required action and/or try again later."
        )
       }
    />
</PayPalScriptProvider>
);
};

export default PayPalCheckout;
